import { render, staticRenderFns } from "./full-page.vue?vue&type=template&id=1561d606&scoped=true"
import script from "./full-page.vue?vue&type=script&lang=js"
export * from "./full-page.vue?vue&type=script&lang=js"
import style0 from "./full-page.vue?vue&type=style&index=0&id=1561d606&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1561d606",
  null
  
)

export default component.exports